<template>
    <div id='Accueil' style='height: 50vh;'>
        <h1>ProLexis WebService</h1>
        <h2>Configuration de l'outil de correction</h2>

        <div v-if="showConfig()">
            <router-link to="/selectSetting">Avant toute modification des paramètres de correction, choisissez le profil sur lequel vous souhaitez intervenir ici.</router-link>
        </div>
        <br/>

        <div id="accueilContent"> 
            <p>Le menu “Expert linguistique” permet de configurer* votre outil de correction afin qu’il réponde aux exigences de votre charte rédactionnelle (dictionnaires, soumissions, etc.).
            </p>
            <p v-if="isSuperAdmin() || isAdmin()">Le menu “Administrateur” permet de gérer les adresses IP, de déclarer les experts linguistiques et administrateurs et de consulter les API. Il offre aussi un accès aux documentations techniques et à une page de test.</p>
            <p>Toute l’équipe de Diagonal vous souhaite un excellent travail avec nos outils.</p>
            <p>*Tous les paramétrages ne sont pas encore disponibles.</p>
        </div>
    

    </div>
</template>

<script>
    import { RoleEnum } from '../classes/enums'
    import FctUtils from '@/components/FctUtils';

    export default { 
        name:"Accueil",
        components: { },
        mixins: [FctUtils],
        mounted() {

        },
        computed:{
            role() {
                return this.$store.state.currentUser.role;
            }
        },
        methods : {
            isLinguist(){
                return this.role == RoleEnum.LINGUIST.value;
            },
            isAdmin(){
                return this.role == RoleEnum.ADMIN.value;
            },
            isSuperAdmin(){
                return this.role == RoleEnum.SUPERADMIN.value;
            },
            showConfig() {
				if (this.$store.state.settings.length == 1) return false;
                if (this.noEmpty(this.$store.state.setting)) return false;
				return true;
			},
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#accueilContent {
    padding-bottom: 100px;

    font-size: 1em;
    line-height: 1.4em;
    text-align: left;
    font-weight: 400;
    color: #3c3c3c;
    letter-spacing: 0;
    margin-bottom: 14px;
}

#accueilContent h1 {
    margin-bottom: 10px;
}

</style>
